const blogHomepageAllArticles = {
  displayField: 'header',
  name: 'Blog Homepage All Articles',
  description: 'Section on blog homepage with all the articles',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'blogHomepageAllArticles',
    version: 11,
    updatedAt: '2023-08-02T21:18:06.706Z'
  }
};
export default blogHomepageAllArticles;